var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-item"},[_c('dt',{staticClass:"info-item__dt"},[_vm._v(_vm._s(_vm.title)+":")]),_c('dd',{staticClass:"info-item__dd"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }